import * as React from 'react';

import tinytime from 'tinytime';
import { Message as AIMessage } from '@ai-sdk/react';

import { useBuilderContext } from '@components/BuilderApp/BuilderContext';
import { Button } from '@components/common/Button';
import { DocCreateSVG } from '@components/svgs';

const dateTemplate = tinytime('{Mo}/{DD}/{YYYY} {h}:{mm}{a}');

interface SavedDraftProps {
  message: AIMessage;
}

export const SavedDraft: React.FC<SavedDraftProps> = ({ message }) => {
  const builderContext = useBuilderContext();

  const handleClick = () => builderContext?.openContent?.(message.id);

  return (
    <Button
      aria-label='Open study draft'
      className='mt-2 flex w-full rounded-lg border border-blue-200 bg-blue-50 p-3 text-left transition-colors hover:bg-blue-100'
      onClick={handleClick}
      noStyle
    >
      <div className='flex w-full items-center space-x-2'>
        <div className='flex items-center justify-center rounded-full bg-indigo-100 p-2'>
          <DocCreateSVG className='h-4 w-4 text-indigo-600' />
        </div>
        <div className='flex min-w-0 flex-col'>
          <div className='text-sm font-medium text-blue-900'>New study draft</div>
          <div className='text-xs text-blue-600'>
            Created on {dateTemplate.render(new Date(message.createdAt || Date.now()))}
          </div>
        </div>
      </div>
    </Button>
  );
};
